/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAWSS3IconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-aws-s3" */ './utils').then((m) => m.AWSS3Icon),
	{ moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon' },
);

const LazyAWSS3SearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-aws-s3-search-result" */ './utils').then(
			(m) => m.AWSS3SearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AWSS3Icon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAWSS3IconComponent />
	</Suspense>
);

export const AWSS3SearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAWSS3SearchResultIconComponent />
	</Suspense>
);
